import { DownOutlined, UpOutlined } from "@ant-design/icons"
import { Form } from "antd"
import { useState } from "react"
import { CustomRangePicker } from "../../../../../../components/custom/customRangePicker"
import { CustomDynamicTable } from "../../../../../../components/custom/customDynamicTable"
import { createGetColumnsFuntion } from "./model"
import dayjs, { Dayjs } from "dayjs"

const groundValue: IProgramEventOutline = {
    id: 0,
    day: [],
    startTime: '00:00',
    programEventList: [],
}

interface IProps {
    initBookingPeriod?: [string, string]
    initProgramPeriod?: [string, string]
    programEventOutlineList: IProgramEventOutline[]
    setProgramEventOutlineList: React.Dispatch<React.SetStateAction<IProgramEventOutline[]>>
    isDefalutOpen?: boolean
}

const ProgramBookingSetting = ({ initProgramPeriod, programEventOutlineList, setProgramEventOutlineList, isDefalutOpen = false }: IProps) => {
    const [isBookingSettingOpen, setIsBookingSettingOpen] = useState<boolean>(isDefalutOpen)
    const [isApplyRecord, setIsApplyRecord] = useState<Record<number, boolean>>(Object.fromEntries(programEventOutlineList.map((q, idx) => [idx, true])));
    const [programPeriod, setProgramPeriod] = useState<[Dayjs, Dayjs]>(initProgramPeriod ? [dayjs(initProgramPeriod[0]), dayjs(initProgramPeriod[1])] : [dayjs(), dayjs().add(30, 'd')])
    const [targetDateTimeListRecord, setTargetDateTimeListRecord] = useState<Record<number, Dayjs[]>>(Object.fromEntries(programEventOutlineList.map((q, idx) => [idx, q.programEventList.map(w => dayjs(w.targetDateTime))])));
    const [dayListRecord, setDayListRecord] = useState<Record<number, (1 | 2 | 3 | 4 | 5 | 6 | 7)[]>>(Object.fromEntries(programEventOutlineList.map((q, idx) => [idx, q.day])))
    const [startTimeRecord, setStartTimeRecord] = useState<Record<number, string>>(Object.fromEntries(programEventOutlineList.map((q, idx) => [idx, q.startTime])));
    const [isActiveListRecord, setIsActiveListRecord] = useState<Record<number, boolean[]>>(Object.fromEntries(programEventOutlineList.map((q, idx) => [idx, q.programEventList.map(w => w.isActive)])))
    const [isMaxBookingCntListRecord, setIsMaxBookingCntListRecord] = useState<Record<number, number[]>>(Object.fromEntries(programEventOutlineList.map((q, idx) => [idx, q.programEventList.map(w => w.maxBookingCnt)])))
    const onClickApplyBtn = (idx: number, isApply: boolean) => {
        setIsApplyRecord(q => {
            const newValue = { ...q }
            newValue[idx] = isApply
            return newValue
        });
        setProgramEventOutlineList(pre => {
            const newPre = [...pre]
            newPre[idx] = { id: pre[idx].id, day: dayListRecord[idx], startTime: startTimeRecord[idx], programEventList: targetDateTimeListRecord[idx].map((q, index) => ({ id: index + 1, targetDateTime: q.toISOString(), maxBookingCnt: isMaxBookingCntListRecord[idx][index], isActive: isActiveListRecord[idx][index] })) }
            return newPre
        })
    }
    const getDatesByWeekday = (targetDays: (1 | 2 | 3 | 4 | 5 | 6 | 7)[] = [], idx: number, targetTime: string = '00:00') => {
        if (!programPeriod[0] || !programPeriod[1]) return
        let current = programPeriod[0].startOf("day");
        const result: Dayjs[] = [];
        while (current.isBefore(programPeriod[1], "day") || current.isSame(programPeriod[1], "day")) {
            if (targetDays.includes(current.day() || 7)) {
                result.push(current?.set("hour", parseInt(targetTime?.split(":")[0]))?.set("minute", parseInt(targetTime?.split(":")[1])));
            }
            current = current.add(1, "day");
        }
        setTargetDateTimeListRecord(q => {
            const newValue = { ...q }
            newValue[idx] = result
            return newValue
        });
        setDayListRecord(q => {
            const newValue = { ...q }
            newValue[idx] = targetDays
            return newValue
        })
        setStartTimeRecord(q => {
            const newValue = { ...q }
            newValue[idx] = targetTime
            return newValue
        });
        setIsActiveListRecord(q => {
            const newValue = { ...q }
            newValue[idx] = result.map(() => true)
            return newValue
        });
        setIsMaxBookingCntListRecord(q => {
            const newValue = { ...q }
            newValue[idx] = result.map(() => 0)
            return newValue
        });
    };
    const getColumns = createGetColumnsFuntion(dayListRecord, startTimeRecord, onClickApplyBtn, getDatesByWeekday)

    return <>
        <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }} onClick={_ => setIsBookingSettingOpen(q => !q)}>
            <div style={{ fontSize: '20px', fontWeight: 600, paddingBlock: '20px' }}>
                예약 설정<span style={{ color: 'var(--ant-color-error)' }}>*</span>
            </div>
            {isBookingSettingOpen
                ? <DownOutlined />
                : <UpOutlined />}
        </div>
        <div style={{ position: 'relative', height: '1px' }}>
            <div style={{ position: 'absolute', left: '-20px', width: 'calc(100% + 40px)', height: '1px', backgroundColor: 'var(--ant-layout-footer-bg)' }} />
        </div>
        <div style={{ transition: 'max-height 0.3s ease, margin-block 0.4s ease', maxHeight: isBookingSettingOpen ? '200vh' : '0', overflow: 'hidden', marginBlock: isBookingSettingOpen ? '24px' : '0' }}>
            <Form.Item
                name='bookingPeriod'
                label='예약기간'
                rules={[{ required: true, message: '예약기간을 선택해주세요' }]}
            >
                <CustomRangePicker />
            </Form.Item>
            <Form.Item
                name='programPeriod'
                label='프로그램 기간'
                rules={[{ required: true, message: '프로그램 기간을 선택해주세요' }]}
            >
                <CustomRangePicker extra="" onChange={q => (q && q[0] && q[1]) && setProgramPeriod([dayjs(q[0]), dayjs(q[1])])} />
            </Form.Item>
            <CustomDynamicTable groundValue={groundValue} dataList={programEventOutlineList} setDataList={setProgramEventOutlineList} getColumns={getColumns} isNoEditColumn footerText="+ 회차 추가" bordered={false} />
        </div>
    </>
}

export { ProgramBookingSetting }